// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD0Nb4YAPzlgH0tWbHqT5fTtPpv6RKB46A",
  authDomain: "almadanza-e18d5.firebaseapp.com",
  projectId: "almadanza-e18d5",
  storageBucket: "almadanza-e18d5.firebasestorage.app",
  messagingSenderId: "493146947154",
  appId: "1:493146947154:web:ca257be278e538342c698b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
